import classNames from 'classnames'
import PropTypes from 'prop-types'

import { makeStyles } from 'beam/dist/styles'

import { autoQaIdPrefix } from './SeekBar'

const useStyles = makeStyles(theme => ({
  playback: props => ({
    position: 'absolute',
    background: theme.palette.color.red[700],
    cursor: 'pointer',
    top: 0,
    left: theme.spacing(1),
    width: theme.spacing(0.5),
    transition: props.isScrubbing ? '' : 'height 0.2s ease-out',
    '&:after': {
      top: 'auto',
      bottom: 0,
      right: '50%',
      transform: 'translate3d(50%, 50%, 0)',
      display: 'inline-block',
      content: '""',
      position: 'absolute',
      borderRadius: '50%',
      width: props.isSeeking ? theme.spacing(1.5) : theme.spacing(1),
      height: props.isSeeking ? theme.spacing(1.5) : theme.spacing(1),
      backgroundColor: theme.palette.common.white,
      boxShadow: `0 0 0 4px ${theme.palette.color.red[700]}`,
      transition: 'all .1s ease-in-out',
      cursor: 'pointer',
    },
  }),
}))

const propTypes = {
  classes: PropTypes.object,
  isScrubbing: PropTypes.bool,
  isSeeking: PropTypes.bool,
  completedPercent: PropTypes.number,
}

const Playback = ({ classes: parentClasses, isSeeking, isScrubbing, completedPercent }) => {
  const classes = useStyles({ isSeeking, isScrubbing })

  return (
    <div
      className={classNames(classes.playback, isSeeking && parentClasses.seeking)}
      style={{ height: `${completedPercent}%` }}
      onDragStart={() => false}
      data-testid={`${autoQaIdPrefix}playback`}
    />
  )
}

Playback.propTypes = propTypes

export default Playback
